import { CoreFetch, ListProviderTransactionsRequest, Transaction, TransactionApi } from '@enter/core';
import { IItemDetail, IItemListing } from './root.store';
import { fetch, parseResponse } from './util';

export class TransactionService {
    public async fetchTransactionListing(
        lpgr: ListProviderTransactionsRequest,
    ): Promise<IItemListing<Transaction> | undefined> {
        const res = await fetch(lpgr, req =>
            CoreFetch<TransactionApi>(TransactionApi).listProviderTransactionsRaw(req),
        );
        if (res) {
            return {
                items: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
    public async fetchTransaction(id: string): Promise<Transaction | undefined> {
        return fetch({ id }, req => CoreFetch<TransactionApi>(TransactionApi).getProviderTransaction(req));
    }
    public async fetchTransactionDetail(guarantorId: string): Promise<IItemDetail<Transaction> | undefined> {
        const item = await fetch(guarantorId, id =>
            CoreFetch<TransactionApi>(TransactionApi).getProviderTransaction({ id }),
        );
        if (item) {
            return {
                item,
            };
        }
    }
}
